/* eslint-disable no-new */
/* eslint-disable no-undef */

import Dragdealer from 'dragdealer';

let componentRegistry = {};

// Function to get a component by question ID
function getComponentByQuestionId(questionId) {
    return componentRegistry[questionId];
}


let hoverMixin = Base => class extends Base {
    /**
     * Issue on apple devices
     * https://developer.apple.com/library/content/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html
     * Here is wrong order of hover events
     * @returns {RegExpMatchArray | null}
     */
    isIos() {
        let device = navigator.userAgent.toLowerCase();
        return device.match(/(iphone|ipod|ipad)/);
    }
};

class InputComponent {
    constructor(block) {
        this.block = $(block);

        // Init input(s)
        this.input = $(block).find(this.inputTag());
        let questionId = this.block[0].parentElement.dataset.questionId;

        if (questionId) {
            componentRegistry[questionId] = this; // Store the component instance in the registry
        }
        this.input.on('change', (event) => this.onChange($(event.currentTarget)));

        this.originalValue = this.input.val();

        // Init reset button
        this.resetButton = $(block).find('.quest-slider-reset');
        this.resetButton.on('click', (event) => {
            this.onReset(event);
        });
        this.resetButton.attr('style', 'display:none !important');
    }

    inputTag() {
        return 'input';
    }

    /**
     *
     * @param value
     */
    setValue(value) {
        this.input.val(value);
    }

    /**
     *
     */
    onChange() {
        this.block.removeClass('mod-error');
        let originalValue = this.originalValue;
        if (originalValue !== this.input.val()) {
            this.resetButton.show();
        }
        let questionId = this.block[0].parentElement.dataset.questionId;

        if (questionId) {
            componentRegistry[questionId] = this; // Store the component instance in the registry
        }
        const elements = $('[data-depends-on="' + questionId + '"]');
        elements.each(function () {
            let component = getComponentByQuestionId(this.dataset.questionId);
            if (component) {
                component.onReset();
            }
        });
    }

    /**
     *
     */
    onReset() {
        this.setValue(this.originalValue);
        this.resetButton.attr('style', 'display:none !important');
    }

    toggleDependedQuestions() {
        // Get all depended questions which should be shown (where trigger choices is selected):

        let displayQuestions = [];
        $("input[type=radio]:checked, option:selected, input[type=checkbox]:checked").each(function () {
            if ($(this).data('questions') !== undefined) {
                let questions = $(this).data('questions').split(',').filter(e => e).map(e => e * 1);
                displayQuestions = displayQuestions.concat(questions);
            }
        });

        // Show only those depended questions where trigger choice is selected:
        $('[data-depended-question="1"]').each(function () {
            let questionId = $(this).data('depended-question-id') * 1;
            displayQuestions.indexOf(questionId) === -1 ? $(this).hide() : $(this).show();
        });

        $('.question-container').each(function () {
            let dependsOn = $(this).data('depends-on') * 1;
            let shouldHide = false;
            if (dependsOn) {
                $('[data-depended-question-id="' + dependsOn + '"]').each(function () {
                    if ($(this).is(":hidden")) {
                        shouldHide = true;
                    }
                });
            }
            if (shouldHide) {
                $(this).hide();
            }
        });

        // Hide section if all questions is hidden:
        toggleSectionsVisibility();
    }
}

class CheckInputComponent extends InputComponent {
    init() {
        this.input.each(function () {
            $(this).data('originalValue', $(this).prop('checked'));
        });
    }

    onChange() {
        this.block.removeClass('mod-error');
        this.resetButton.show();
    }

    onReset() {
        this.resetButton.attr('style', 'display:none !important');
        this.input.prop('checked', false);
    }
}

class InputRateComponent extends hoverMixin(InputComponent) {
    constructor(block) {
        super(block);
        this.textIndicatorBlock = this.block.find('.text-indicator');
        this.textIndicatorBlock.find('span[data-value]').hide();

        this.sliderUpdates = 0;
        this.sliderInitialValue = 0;
        this.slider = null;
        this.sliders = null;

        const sliders = this.block.find('.weighting');
        if (sliders.length > 0) {
            this.sliders = sliders;
        }

        let that = this;
        if (!this.isIos()) {
            this.block.find('.star-block').on('mouseenter', function () {
                that.updateBlock($(this).data('value'));
            });
            this.block.find('.stars-block').on('mouseleave', function () {
                that.updateBlock(parseInt(that.input.val()));
            });
        }
        this.block.find('.star-block').on('click touchend', function () {
            that.setValue($(this).data('value'));
            that.updateBlock($(this).data('value'));
        });
    }

    inputTag() {
        return 'input[type="hidden"]';
    }

    setValue(value) {
        let number = parseInt(value);
        if (!isNaN(number)) {
            this.input.val(number);
        } else {
            this.input.val('');
        }
        this.onChange();


        if (this.sliders) {
            if (this.input.val()) {
                this.sliders.removeClass('d-none');
                this.initSlider(this.sliders);
            } else {
                this.sliders.addClass('d-none');
            }
        }
    }

    onReset() {
        super.onReset();
        this.updateBlock(parseInt(this.input.val()));
        this.sliderUpdates = 0;
        if (this.slider) {
            this.slider.setStep(this.sliderInitialValue);
        }
    }

    updateBlock(value) {
        this.showTextIndicator(value);
        this.block.find('.star-block').each(function () {
            let val = parseInt($(this).data('value'));
            let starMainIcon = $(this).find('.star-icon-main');

            if (val <= value) {
                starMainIcon.removeClass('d-none');
                starMainIcon.addClass('mod-active');
            } else {
                starMainIcon.addClass('d-none');
                starMainIcon.removeClass('mod-active');
            }
        });
    }

    showTextIndicator(value) {
        this.textIndicatorBlock.find('span[data-value]').hide();
        this.textIndicatorBlock.find('span[data-value=' + value + ']').show();
    }

    initSlider(el) {
        const input = el.find('input[type=range]');
        const bgRail = el.find('.slider-rail-inner'); // the one with a progressing background
        const text = el.find('.slider-text'); // textural representation of weighting
        const initialValue = this.sliderInitialValue = input.val();
        const self = this;

        // how much is one step in percents?
        const delta = input.attr('step') * 100 / (input.attr('max') - input.attr('min'));

        this.slider = new Dragdealer(el.find('.slider-toggle')[0], {
            handleClass: 'slider-toggle-btn',
            steps: 5,
            snap: true,
            slide: false,
            animationCallback() {
                const step = this.getStep()[0];
                const zbStep = step - input.attr('step'); // zero-based step
                bgRail.css('width', (zbStep * delta) + '%');

                text.text(el.find('.slider-dots-dot').eq(zbStep).data('text'));
            },
            callback() {
                if (self.sliderUpdates > 0) {
                    self.resetButton.show();
                }
                const step = this.getStep()[0];
                input.val(step);
                input.trigger('input');
                self.sliderUpdates++;
            }
        });
        this.slider.setStep(initialValue, null, true);

        // bind rail dots
        el.find('.slider-dots-dot').click(function () {
            self.slider.setStep($(this).data('index'), null, true);
        });
    }
}

class InputMultichoiceComponent extends CheckInputComponent {
    onChange() {
        super.onChange();
        this.toggleDependedQuestions();
    }

    onReset() {
        super.onReset();
        this.toggleDependedQuestions();
    }
}

class InputCheckboxComponent extends CheckInputComponent {
}

class InputExtendedNpsComponent extends InputComponent {
    constructor(block) {
        super(block);
        this.block.find('.promoter-score-item').on('click touched', (event) => {
            this.onClick($(event.currentTarget));
        });
    }

    onClick(item) {
        this.block.find('.promoter-score-item').removeClass('active');
        item.addClass('active');
        this.setValue(item.data('value'));
        this.onChange(item);
    }

    onReset() {
        super.onReset();
        this.block.find('.promoter-score-item').removeClass('active');
    }
}

class InputTenPointScaleComponent extends InputComponent {
    constructor(block) {
        super(block);
        this.block.find('.ten-point-scale-score-item').on('click touched', (event) => {
            this.onClick($(event.currentTarget));
        });
    }

    onClick(item) {
        this.block.find('.ten-point-scale-score-item').removeClass('active');
        item.addClass('active');
        this.setValue(item.data('value'));
        this.onChange(item);
    }

    onReset() {
        super.onReset();
        this.block.find('.ten-point-scale-score-item').removeClass('active');
    }
}

class InputTextComponent extends InputComponent {
    inputTag() {
        return 'input, textarea';
    }
}

class InputNpsComponent extends CheckInputComponent {
}

class InputChoiceComponent extends CheckInputComponent {
    onChange(element) {
        super.onChange();
        this.toggleDependedQuestions();
    }

    onReset(element) {
        super.onReset();
        this.toggleDependedQuestions();
    }
}


const toggleSectionsVisibility = () => {
    $('.section-container').each(function () {
        let displaySection = false;
        $(this).find('.question-container').each(function () {
            if ($(this).css('display') !== 'none') {
                displaySection = true;
            }
        });
        displaySection ? $(this).show() : $(this).hide();
    });
};

(function ($) {
    if (typeof require !== 'undefined') {
        var customSelect = require('custom-select').default;
    }

    /*
      * In this example we use native select on touch devices only.
      * You could combine touch detection and media query for a better result or you could detect the the specific OS
      * for decide when to use customSelect panel and when to use native select.
      * Modernizer could be a good choice in this way.
      */
    if (('ontouchstart' in window) || (window.DocumentTouch && document instanceof window.DocumentTouch)) {
        document.documentElement.classList.add('is-touch');
    }

    $('.info-icon').tooltip();


    class InputSelectComponent extends InputComponent {
        constructor(block) {
            super(block);
            this.select = this.block.find('select');
            this.customSelect = customSelect(this.select);

            // Hack for hide scroll on short list
            this.customSelect[0].container.addEventListener('custom-select:open', (e) => {
                window.setTimeout(() => {
                    $(e.target).find('.custom-select-panel').attr('style', 'overflow-y: auto;');
                }, 500);
            });
            this.customSelect[0].container.addEventListener('custom-select:close', (e) => {
                $(e.target).find('.custom-select-panel').attr('style', 'overflow-y: hidden;');
            });

            this.customSelect[0].select.addEventListener('change', () => {
                this.setValue(this.customSelect[0].value);
                this.onChange(this.input);
            });
        }

        onChange(element) {
            super.onChange();
            this.toggleDependedQuestions();
        }

        onReset(element) {
            super.onReset();
            this.customSelect[0].value = 'none';
            this.toggleDependedQuestions();
        }
    }

    // Bind rate inputs
    $('.input-rate-block').each(function () {
        return (new InputRateComponent($(this)));
    });

    $('.input-select-block').each(function () {
        return (new InputSelectComponent($(this)));
    });

    $('.input-multichoice-block').each(function () {
        return (new InputMultichoiceComponent($(this)));
    });

    $('.input-checkbox-block').each(function () {
        return (new InputCheckboxComponent($(this)));
    });

    $('.input-extented-nps').each(function () {
        return (new InputExtendedNpsComponent($(this)));
    });

    $('.input-ten-point-scale').each(function () {
        return (new InputTenPointScaleComponent($(this)));
    });

    $('.input-text-block').each(function () {
        return (new InputTextComponent($(this)));
    });

    $('.input-nps-block').each(function () {
        return (new InputNpsComponent($(this)));
    });

    $('.input-choice-block').each(function () {
        return (new InputChoiceComponent($(this)));
    });

    toggleSectionsVisibility();

    /**
     * Form component
     *
     * @param form JQuery
     */
    let formComponent = function (form) {
        let url = location.href;
        let displayErrors = function (errors) {
            for (let error in errors) {
                let inputName = errors[error].input;
                let message = errors[error].message;
                let input = $('[name^="' + inputName + '"]');
                let inputBlock = input.closest('.block-question');
                let errorMsg = inputBlock.find('.sqq-text-error');
                errorMsg.text(message);
                inputBlock.addClass('mod-error');
            }

            window.scrollTo(0, $('.mod-error:first').offset().top);
        };

        let submit = function (event) {
            $('#submit-survey').attr('disabled', true);
            $('.question-container').each(function () {
                if ($(this).is(':hidden')) {
                    $(this).html('');
                }
            });
            event.preventDefault();
            $.post(url, form.serializeArray()).done(function (response) {
                if (response.redirect) {
                    location.href = response.redirect;
                }
            }).fail(function (response) {
                $('#submit-survey').attr('disabled', false);
                if (response.responseJSON.errors) {
                    displayErrors(response.responseJSON.errors);
                }
            });
            return false;
        };

        form.on('submit', submit);
    };
    formComponent($('form'));
}(jQuery));
